import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

export const StyledInput = styled(TextField)(({ theme }) => ({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    borderRadius: "4px", // Bootstrap default
    padding: "3px 3px 3px 8px",
    width: "100%",
    height: "32px",
    display: "flex",
    backgroundColor: theme.palette.mode === "light" ? "#fff" : "#2b2b2b",
    "& input": {
      padding: 0,
      fontSize: "14px",
      color: "#555555",
    },
    "& .MuiInputAdornment-root": {
      maxHeight: "100%",
      color: "#555555",
      background: "transparent",
      borderRadius: "4px 0px 0px 4px",
      fontSize: "14px",
      alignItems: "center",
    },
    "& .MuiInputAdornment-positionEnd": {
      borderRadius: "0px 4px 4px 0px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C9C9C9", // Bootstrap's default border color
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#86b7fe", // Bootstrap's focus border color
      borderWidth: "1px",
      boxShadow: "none", // Bootstrap's focus shadow
      fontSize: "16px",
      fontWeight: "400",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da", // Default border color
    padding: "3px",
  },
  "& .MuiInputLabel-outlined": {
    "&.Mui-focused": {
      color: "#86b7fe", // Label color when focused
    },
  },
}));
